export default __webpack_public_path__ + "static/media/rotate-icon.149b0616.svg";